module.exports = __webpack_public_path__ + "media/images/wealthbar/dashboard/checkmark-icon-52e67b4807dcf9e3cf1a66d165bfbfae.png";